import AppHelper from "helpers/AppHelper";
import { iconTypeExercise } from "assets/icons";
import {
  IconLeadership,
  IconRecipe,
  IconOnDemand,
  IconELearning,
  IconFitnessNutrition,
} from "assets/images";
import { ContentType } from "../constants/content-type";
import { initialDays } from "../constants/app.constants";
import { Section } from "components/Base/Weeks/types";

export const LIST_FILTER = [
  { display: "All BRIKs", value: -1 },
  { display: "E-learning course", value: 0 },
  { display: "Programs", value: 1 },
  { display: "Challenges", value: 2 },
  { display: "Recipes", value: 3 },
  { display: "Exercises", value: 4 },
  // { display: 'Creating Life & Leadership Coaching', value: 5 },
  { display: "On Demand", value: 6 },
];

export const TABS = [
  { display: "All", value: -1 },
  { display: "Courses", value: 0 },
  { display: "Programs", value: 1 },
  { display: "Challenges", value: 2 },
  { display: "Recipes", value: 3 },
  { display: "Exercises", value: 4 },
  // { display: 'Creating Life & Leadership Coaching', value: 5 },
  { display: "On Demand", value: 6 },
];

export const APP_STATUS = {
  NOT_SUBMITED: 0,
  HAVE_CHANGE: 1,
  REVIEWING: 2,
  SUBMITED: 3,
};

export const STEP_CREATE_BRIK = {
  CHOOSE_BRIK_TYPE_NAME: 0,
  CHOOSE_BRIK_TYPE_TYPE: 1,
  CHOOSE_BRIK_SCHEDULE: 2,
  CHOOSE_BRIK_TYPE: 3,
  CREATE_BRIK_DETAIL: 4,
  CHOOSE_BRIK_SECTION: 5,
};

export const DUPLICATE_BRIK = {
  CHOOSE_BRIK_TYPE: 0,
  CREATE_BRIK_DETAIL: 1,
};

export const TYPE_NAME_BRIK = {
  LESSON: 0,
  PROGRAM: 1,
  CHALLENGE: 2,
  RECIPE: 3,
  EXERCISE: 4,
  ON_DEMAND: 5,
  FITNESS_NUTRITION: 6,
  LIFE_LEADERSHIP_COACHING: 7,
};

export enum SUMMARY_TYPE {
  TOTAL,
  CANCELLED,
  NEW_CLIENT_PRIVATE,
  NEW_CLIENT_PUBLIC,
}

export enum GRAPH_TYPE {
  PUBLIC_STAND_ALONE,
  PUBLIC_SUBSCRIPTION,
  PRIVATE,
}

export const TYPE_BRIK = {
  SUBSCRIBERS: 0,
  GROUPS: 1,
  EVERYONE: 2,
};

export const TYPE_SECTION = {
  CONTENT: 0,
  MEAL: 1,
  WORKOUT: 2,
};

export const BRIK_STATUS = {
  LIVE: "live",
  SHARED: "shared",
  HIDDEN: "hidden",
  DRAFT: "In Draft",
  NOT_SHARED: "Not Shared",
};

export const TYPE_PAYMENT_BRIK = {
  SUBCRIPTION: 0,
  ONE_TIME: 1,
  MONTHLY: 2,
};

export const TYPE_LENGTH = {
  NO_DURATION: 0,
  DAY: 1,
  WEEK: 2,
};

export const WORKOUT_DIFFICULTY = [
  { display: "Beginner", value: 0 },
  { display: "Intermediate", value: 1 },
  { display: "Advanced", value: 2 },
];

export const LIST_HOURS_WORKOUT = [
  { display: "0 hour", value: 0 },
  { display: "1 hour", value: 1 },
  { display: "2 hours", value: 2 },
  { display: "3 hours", value: 3 },
];

export const LIST_MINUTES_WORKOUT = [
  { display: "0 minute", value: 0 },
  { display: "5 minutes", value: 5 },
  { display: "10 minutes", value: 10 },
  { display: "15 minutes", value: 15 },
  { display: "20 minutes", value: 20 },
  { display: "25 minutes", value: 25 },
  { display: "30 minutes", value: 30 },
  { display: "35 minutes", value: 35 },
  { display: "40 minutes", value: 40 },
  { display: "45 minutes", value: 45 },
  { display: "50 minutes", value: 50 },
  { display: "55 minutes", value: 55 },
];

export const LIST_WORKOUT_UNIT = [
  { display: "rep/s", value: "reps" },
  { display: "second/s", value: "seconds" },
  { display: "minute/s", value: "minutes" },
];

export const LIST_WORKOUT_DEFAULT = [
  { display: "0", value: 0 },
  { display: "1", value: 1 },
  { display: "2", value: 2 },
  { display: "3", value: 3 },
  { display: "4", value: 4 },
  { display: "5", value: 5 },
  { display: "6", value: 6 },
  { display: "7", value: 7 },
  { display: "8", value: 8 },
  { display: "9", value: 9 },
  { display: "10", value: 10 },
  { display: "11", value: 11 },
  { display: "12", value: 12 },
  { display: "13", value: 13 },
  { display: "14", value: 14 },
  { display: "15", value: 15 },
];

export const generateBriks = (
  nextStep: (e: any, type: any) => void,
  handleSetTypeName?: (type: number) => void
) => {
  const onClickChooseBrikType = (e: any, type: number) => {
    if (handleSetTypeName) {
      handleSetTypeName(type);
    }

    if (
      type === TYPE_NAME_BRIK.LESSON ||
      type === TYPE_NAME_BRIK.PROGRAM ||
      type === TYPE_NAME_BRIK.CHALLENGE ||
      type === TYPE_NAME_BRIK.FITNESS_NUTRITION ||
      type === TYPE_NAME_BRIK.LIFE_LEADERSHIP_COACHING
    ) {
      nextStep(e, type);
    } else if (type === TYPE_NAME_BRIK.RECIPE) {
      AppHelper.showCreateRecipe({ isCreate: true });
    } else if (type === TYPE_NAME_BRIK.EXERCISE) {
      AppHelper.showCreateExercise({ isCreate: true });
    }
  };

  return [
    {
      image: IconELearning,
      title: "Course",
      description:
        "Create insightful & engaging public or private E-learning courses",
      onPress: (e: any) => onClickChooseBrikType(e, TYPE_NAME_BRIK.LESSON),
    },
    {
      image: IconFitnessNutrition,
      title: "Fitness & Nutrition Coaching",
      description: "Build impactful public or private programs and challenges",
      onPress: (e: any) =>
        onClickChooseBrikType(e, TYPE_NAME_BRIK.FITNESS_NUTRITION),
    },
    {
      image: IconLeadership,
      title: "Life & Leadership Coaching",
      description:
        "Build life-changing public or private programs or challenges",
      onPress: (e: any) =>
        onClickChooseBrikType(e, TYPE_NAME_BRIK.LIFE_LEADERSHIP_COACHING),
    },
    {
      image: IconOnDemand,
      title: "On Demand",
      description:
        "Accessible to all users, create content like text, videos and workouts",
      onPress: (e: any) => onClickChooseBrikType(e, TYPE_NAME_BRIK.ON_DEMAND),
    },
    {
      image: IconRecipe,
      title: "Recipe",
      description:
        "Customers will have access to all recipes. Recipes are saved for you to easily add again.",
      onPress: (e: any) => onClickChooseBrikType(e, TYPE_NAME_BRIK.RECIPE),
    },
    {
      image: iconTypeExercise,
      title: "Single Exercise",
      description:
        "Create an exercise for physical fitness, therapy, and stretches. Exercises are saved for you to easily add again.",
      onPress: (e: any) => onClickChooseBrikType(e, TYPE_NAME_BRIK.EXERCISE),
    },
  ];
};

export const filterSectionList = (
  listSection: any,
  periodType: string,
  day: any,
  week: any,
  shouldSort: boolean = false
) => {
  const sections = {
    section_content: [],
    section_meal: [],
    section_workout: [],
  };

  type SectionCategories = keyof typeof sections;

  const sortSections = () => {
    Object.keys(sections).forEach((sectionCategory: string) => {
      const sortedSections = sections[
        sectionCategory as SectionCategories
        //@ts-ignore
      ].sort((section1, section2) => section1.order - section2.order);

      sections[sectionCategory as SectionCategories] = sortedSections;
    });
  };

  const setSectionType = (section: any, sectionCategory: SectionCategories) => {
    section.type = sectionCategory.replace("section_", "");
    return section;
  };

  if (periodType === "Week") {
    Object.keys(sections).forEach((sectionCategory: string) => {
      const filteredSections = listSection?.[sectionCategory]
        .filter((section: Section) => section?.day_id === day?.id)
        .map((section: Section) =>
          setSectionType(section, sectionCategory as SectionCategories)
        );
      sections[sectionCategory as SectionCategories] = filteredSections;
    });

    if (shouldSort) {
      sortSections();
    }

    return {
      listSectionContentOfDay: sections["section_content"] || [],
      listSectionMealOfDay: sections["section_meal"] || [],
      listSectionWorkoutOfDay: sections["section_workout"] || [],
    };
  } else {
    Object.keys(sections).forEach((sectionCategory: string) => {
      const filteredSections = listSection[sectionCategory]
        .filter((section: any) => section?.length_id === week?.id)
        .map((section: any) =>
          setSectionType(section, sectionCategory as SectionCategories)
        );
      sections[sectionCategory as keyof typeof sections] = filteredSections;
    });

    if (shouldSort) {
      sortSections();
    }

    return {
      listSectionContentOfDay: sections["section_content"] || [],
      listSectionMealOfDay: sections["section_meal"] || [],
      listSectionWorkoutOfDay: sections["section_workout"] || [],
    };
  }
};

export const goToDetailPage = (
  item: any,
  index: number,
  type: string,
  history: any
) => {
  let url = `/brik/${item?.brik_id}/content/${item?.id}/type`;

  if (type === ContentType.CONTENT) {
    url = `${url}/content`;
  } else if (type === ContentType.MEAL) {
    url = `${url}/meal`;
  } else if (type === ContentType.WORKOUT) {
    url = `${url}/workout`;
  }

  history.push(url, {
    section: item,
    currentLengthId: item?.length_id,
    currentDayId: item?.day_id,
    index,
  });
};

export const goToDetailContentPage = (
  brik_id: string,
  res: any,
  history: any
) => {
  const { payload } = res;
  let url = `/brik/${brik_id}/content/${payload?.id}/type`;

  if (payload?.type_section === TYPE_SECTION.CONTENT) {
    url = `${url}/content`;
  } else if (payload?.type_section === TYPE_SECTION.MEAL) {
    url = `${url}/meal`;
  } else if (payload?.type_section === TYPE_SECTION.WORKOUT) {
    url = `${url}/workout`;
  }
  history.push(url, {
    section: payload,
    currentLengthId: payload?.length_id,
    currentDayId: payload?.day_id,
  });
};

export const getDayHeaderName = (
  dayIndex: number,
  weekIndex: number,
  periodType: "Day" | "Week" | "",
  weeklyViewMode: number
) => {
  if (periodType === "Day") {
    return `Day ${dayIndex + 1}`;
  }
  if (weeklyViewMode === 0) {
    return `Day ${weekIndex * 7 + dayIndex + 1}`;
  } else if (weeklyViewMode === 1) {
    return initialDays[dayIndex].name;
  }

  return;
};

export const MENU_TYPES = {
  TEXT: 'null',
  TEXT_9: '9',
  GIF: '3',
  AUDIO: '4',
  VIDEO: '2',
  IMAGE: '1',
  EMBED: '13',
  RECIPE: '10',
  EXERCISE: '14',
  REST: '15',
  CONTENT: '5',
  MEAL: '5', 
  WORKOUT: '5',
  BREAKFAST: '5',
  LUNCH: '6',
  DINNER: '7',
  SNACK: '8',
  WARMUP: '11',
  COOLDOWN: '12',
  WORKOUT_13: '13',

  SAVED: 'saved',
}

export const FILE_MAX_UPLOAD = 10485760;